import { State } from './types';

const initialState: State = {
	allEnterpriseProjects: []
};

export default initialState;
